import { Image } from '@graphcommerce/image'
import { Tooltip } from '@mui/material'
import icon3 from '../../assets/images/home-customer-obsessed.svg'
import icon1 from '../../assets/images/home-highest-quality-standard-icon.svg'
import icon4 from '../../assets/images/home-keeping-it-green-icon.svg'
import icon2 from '../../assets/images/home-unlimited-proofs.svg'
import { IconDescriptionGrid } from '../Home/WhyUseTempli'

export function OrderProcess() {
  const data: IconDescriptionGrid[] = [
    {
      step: 1,
      icon: icon1,
      title: 'Choose your item and upload your art.',
      details:
        'High quality JPG, PDF, or Vector format (svg, eps) or an AI (Adobe Illustrator) file.',
    },
    {
      step: 2,
      icon: icon2,
      title: 'Add item to cart and complete checkout.',
      details: 'We accept several payment methods, as well as the option to PayLater with Paypal.',
    },
    {
      step: 3,
      icon: icon3,
      title: 'Receive unlimited proofs.',
      details:
        'If you opted for proofing before printing, you must approve your proof in “Your Orders” tab before it goes to production.',
    },
    {
      step: 4,
      icon: icon4,
      title: 'Order ships!',
      details: 'You’ll automatically receive an email with your tracking information. ',
    },
  ]
  return (
    <div className='hidden w-full flex-col items-center justify-center rounded-[16px] bg-[#FCF8FF99] py-8 md:flex'>
      <div className='bg-trans mx-[10px] w-full max-w-maxContentWidth px-5 md:mx-[20px] md:px-[60px]'>
        <div className=' grid grid-cols-4 items-center justify-center justify-items-center gap-3'>
          {data.map((item) => (
            <div className='flex h-full flex-col items-center justify-between gap-y-5'>
              <div className='flex flex-col items-center justify-center gap-y-3 text-black'>
                <div className='flex w-full items-start'>
                  <div className='Type-XL-Bold rounded-[50%] bg-[#F4E9FF] p-2 px-[13px] text-bright-templi-purple'>
                    {item?.step}
                  </div>
                </div>
                <div className='flex items-center justify-center rounded-[50%] bg-material-ui-blue/5 p-5'>
                  <Image
                    unoptimized
                    src={item?.icon}
                    height={60}
                    width={60}
                    layout='fixed'
                    className='flex h-[60px] w-[60px] items-center justify-center'
                  />
                </div>
                <span className='Type-XL-Medium hidden text-center md:block'>{item.title}</span>
                <span className='Type-Large-Regular hidden text-center md:block'>
                  {item.details}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
